@if (!loading) {
  <!-- Details-Dialog for the organisation -->
  <p-dialog [header]="i18n?.i18nLng()['DETAILS']"
            [modal]="true"
            [(visible)]="showOrganisationDetailsDialog"
            [style]="{width: '57rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false"
            (visibleChange)="$event === false ? closeDetailsDialog() : null">
    <div class="flex align-items-start gap-3 align-self-stretch">
      <div class="contact-card gray">
        <div class="flex p-2 flex-column align-items-start gap-2 flex-1-0-0">
          <div class="flex align-items-start gap-2 align-self-stretch">
            <div class="flex flex-column align-items-start gap-1 flex-1-0-0">
              <div class="contact-text title">
                {{ selectedRowData?.name }}
              </div>
              <div class="contact-text">
                {{ selectedRowData?.streetNr }}
              </div>
              <div class="contact-text">
                {{ selectedRowData?.postalCode }}&nbsp;{{ selectedRowData?.city }}
              </div>
            </div>
            @if (selectedRowData?.customerStatus) {
              <p-tag [value]="selectedRowData.customerStatus | customerStatusTag : 'VALUE'"
                     [severity]="selectedRowData.customerStatus | customerStatusTag : 'SEVERITY'"
                     [icon]="selectedRowData.customerStatus | customerStatusTag : 'ICON'"/>
            }
          </div>
          <div class="contact-text p-t-1 p-b-1 align-self-stretch">
            <span class="title">{{ i18n.i18nLng()['MERCHANTIDSHORT'] }}:&nbsp;</span><span>{{ selectedRowData?.displayCustomerNumber }}</span>
          </div>
          <!--
          <div class="contact-text p-t-1 p-b-1 align-self-stretch">
            <span class="title">{{ i18n.i18nLng()['CUSTOMERGROUP'] }}:&nbsp;</span>
            <span>{{ i18n.i18nLng()['CUSTOMER_GROUP_' + (selectedRowData?.customerGroup ? selectedRowData?.customerGroup : CustomerGroup.DIRECT)] }}</span>
          </div>
          -->
          @if (selectedRowData?.dataCenterId) {
            <div class="contact-text align-self-stretch">
              <div class="title">{{ i18n.i18nLng()['DATACENTER'] }}:</div>
              <div>{{ selectedRowData?.dataCenter }}</div>
            </div>
          }
        </div>
      </div>
<!--
      <div class="contact-card white">
        <div class="flex p-2 flex-column align-items-start gap-2 flex-1-0-0">
          <div class="contact-text title">
            {{ i18n.i18nLng()['PRIMARYCONTACT'] }}
          </div>
          <div class="contact-text">
            {{ selectedOrgaContactPerson?.firstName }}&nbsp;{{ selectedOrgaContactPerson?.lastName }}
          </div>
          <div class="contact-text">
            <span class="title">E-Mail:&nbsp;</span><span>{{ selectedOrgaContactPerson?.email }}</span>
          </div>
          <div class="contact-text pb-1">
            <span class="title">{{ i18n.i18nLng()['PHONE'] }}:&nbsp;</span><span>{{ selectedOrgaContactPerson?.phone }}</span>
          </div>
          @if (selectedRowData?.bankId) {
            <div class="contact-text align-self-stretch">
              <div class="title">{{ i18n.i18nLng()['SAVINGBANK'] }}:</div>
              <div>{{ selectedRowData.bank }}</div>
            </div>
          }
        </div>
      </div>
  -->
    </div>
    <div class="flex flex-column align-self-stretch mt-2">
      <p-table [value]="organisationPaymentTypes"
               [selectionMode]="userHasTechRole ? 'single' : null"
               [(selection)]="selectedPaymentType"
               (onRowSelect)="onPaymentRowSelected($event)"
               [scrollable]="true"
               scrollHeight="20rem">
        <ng-template pTemplate="header">
          <tr>
            <th class="large-icon-cell force-size"></th>
            <th>{{ i18n?.i18nLng()['PAYMENTTYPES'] }}</th>
            <!--
            <th>{{ i18n?.i18nLng()['UPDATEDAT'] }}</th>
            -->
            <th>{{ i18n?.i18nLng()['STATUS'] }}</th>
            @if (userHasTechRole) {
              <th></th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pt>
          <tr [pSelectableRow]="pt">
            <td class="large-icon-cell force-size">
              @if (pt.customIcon) {
                <sps-custom-icon [name]="pt.icon" [alt]="i18n.i18nLng()[pt.paymentMethod]" [size]="21"></sps-custom-icon>
              } @else {
                <i [ngClass]="pt.paymentMethod | keyToIcon"></i>
              }
            </td>
            <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis purpose-cell">
              {{ pt.title }}
            </td>
            <!--
            <td class="date-time-cell">
              {{ pt.updatedAt | date : 'dd.MM.yyyy - HH:mm' }}
            </td>
            -->
            <td>
              <sps-payment-status-tag [status]="pt.status"></sps-payment-status-tag>
            </td>
            @if (userHasTechRole) {
              <td class="table-toggler-icon align-items-center" style="width: 28px">
                <i class="pi pi-chevron-right"></i>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
    <ng-template #footer class="pt-3">
      <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeDetailsDialog()"/>
    </ng-template>
  </p-dialog>

  <!-- Details-Dialog for the technical payment-type data -->
  <p-dialog [header]="i18n?.i18nLng()['PAYMENTTYPETECHDATA']"
            [modal]="true"
            [(visible)]="showPaymentTypeTechData"
            [style]="{width: '32rem'}"
            [closable]="true"
            [resizable]="false"
            [draggable]="false">
    <div class="flex align-items-start gap-3 align-self-stretch">
    </div>
    <div class="flex flex-column align-self-stretch">
      <sps-data-view-table [headerTitle]="selectedPaymentType?.title"
                           [tableData]="tableDataPaymentTypeTechSpecs" titleColumnWidth="160px">
      </sps-data-view-table>
    </div>
    <ng-template #footer class="pt-3">
      <p-button [label]="i18n.i18nLng()['CLOSE']" (onClick)="closeTechDataDialog()"/>
    </ng-template>
  </p-dialog>

  <!-- Organisation table -->
  <p-card class="h-full">
    <ng-template pTemplate="title">
      <div class="flex flex-1 gap-2 align-self-stretch align-items-center">
        <div class="flex flex-1 align-items-center gap-3">
          <div style="word-break: keep-all">{{ totalRecords.toString() + ' ' + i18n?.i18nLng()['CUSTOMERS'] }}</div>
        </div>
        <p-button [label]="i18n.i18nLng()['CLEAR']"
                  [ariaLabel]="i18n?.i18nLng()['CLEARALLFILTERS']"
                  [pTooltip]="i18n?.i18nLng()['CLEARALLFILTERS']"
                  tooltipPosition="top"
                  [outlined]="true"
                  icon="pi pi-filter-slash"
                  (click)="clearTableFilters()"/>
      </div>
    </ng-template>
  @if (!tableControlService.refreshTableConfig()) {
    <sps-table [tableConfig]="tableConfig()"
               [rows]="rows"
               [tableListProvider]="tableListProvider"
               [parentDataProvider]="getOrganisationPageData"
               [parentDataMapper]="organisationDataMapper"
               [tableControlService]="tableControlService"
               [scrollHeightOffset]="scrollHeightOffset"
               [minScrollHeight]="minScrollHeight"
               [freezeColumns]="true"
               [showTogglerIcon]="true"
               (tableInitialized)="tableComponent = $event"
               (dataFetched)="onDataFetched($event)"
               (selectionChanged)="onSelectionChanged($event)"
               (rowsCountChanged)="rowsCountChanged($event)">
    </sps-table>
  }
  </p-card>
}
